import { useContext } from "react";
import { IconButton, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, Tooltip, Zoom } from "@mui/material";
import { customersContext } from '../CustomersContext';
import { DeleteIconButton, EditIconButton } from "components";
import { useIntl } from "react-intl";
import { LocalizationIds } from "helpers/Localizations";
import { BiMailSend as ResendEmailIcon } from 'react-icons/bi';
import { appUserContext } from "helpers/services";
import { MdRestore } from 'react-icons/md';
import Moment from "react-moment";

let Results = () => {
    let { formatMessage } = useIntl();
    let service = useContext(customersContext);
    let { currentUser } = useContext(appUserContext);

    return (
        <>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Cliente</TableCell>
                        <TableCell>Nome</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell>Creato il</TableCell>
                        <TableCell />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {service.customers.map((customer, index) =>
                        <TableRow hover key={index}>
                            <TableCell>{customer.customerName}</TableCell>
                            <TableCell>{customer.fullName}</TableCell>
                            <TableCell>{customer.email}</TableCell>
                            <TableCell>
                                <Moment date={customer.createdOn} format="LL" />
                            </TableCell>
                            <TableCell align="right">
                                {customer.isDeleted === false &&
                                    <>
                                        <Tooltip title={formatMessage({ id: LocalizationIds.ResendEmailInvitation })} TransitionComponent={Zoom}>
                                            <IconButton
                                                size="small"
                                                color="secondary"
                                                onClick={async (ev) => {
                                                    ev.stopPropagation();
                                                    await service.reSendEmail(customer.email);
                                                }}
                                            >
                                                <ResendEmailIcon />
                                            </IconButton>
                                        </Tooltip>
                                        <EditIconButton link={`/customer/edit/${customer.id}`} />
                                        <DeleteIconButton onClick={() => service.deleteCustomer(customer.id)} />
                                    </>
                                }
                                {customer.isDeleted === true &&
                                    <Tooltip title={formatMessage({ id: LocalizationIds.RestoreUser })} TransitionComponent={Zoom}>
                                        <IconButton
                                            size="small"
                                            color="secondary"
                                            onClick={(ev: any) => service.restoreUser(customer.id)}
                                        >
                                            <MdRestore />
                                        </IconButton>
                                    </Tooltip>
                                }
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
                {service.customers.length === 0 &&
                    <TableFooter>
                        <TableRow>
                            <TableCell colSpan={5}><i>Nessun cliente trovato</i></TableCell>
                        </TableRow>
                    </TableFooter>
                }
            </Table>
            <TablePagination
                component="div"
                count={service.recordCount}
                onPageChange={(e, pageNr) => service.handleChangePage(pageNr)}
                page={service.search.pageNr}
                rowsPerPage={service.search.pageSize}
                rowsPerPageOptions={[service.search.pageSize]}
                labelDisplayedRows={({ page, count }) =>
                    <>
                        Clienti trovato:&nbsp;{count} &nbsp;&middot;&nbsp;
                        <span>Pagina {page + 1} di {Math.ceil(count / service.search.pageSize)}</span>
                    </>
                }
            />
        </>
    )
}

export default Results;